import AlignIcon from "@cirrus/legacy/app-components/icons/alignIcon.jsx"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import PropTypes from "prop-types"
import { cx } from "ramda-extension"
import React, { Component as C } from "react"

import styles from "./index.less"

class Title extends C {
  static displayName = "Title_Eas"

  static propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)
  }

  render() {
    const containerClass = cx(this.props.containerClassName)
    const titleClass = cx(styles.pageTitle, this.props.className)

    return (
      <div className={containerClass} data-qa="page-title">
        {this.props.icon != null ? (
          <AlignIcon width="40px" height="40px" top="10px" facadeClassName={styles.iconFacade}>
            <Icon icon={this.props.icon} className={styles.icon} />
          </AlignIcon>
        ) : null}
        <h2 className={titleClass}>{this.props.title}</h2>
      </div>
    )
  }
}

export default Title
